var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.isLoading}},[_c('div',[_c('pricing-plan'),_c('trial-plan'),_c('faq-plan')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }